import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';

import { Observable } from 'rxjs';

import { BodyListResponse } from 'src/app/core/models/general/body-list-response';
import { BodyResponse } from 'src/app/core/models/general/body-response';

import { InformacionBancariaDTO } from 'src/app/core/models/persona/interfaces';

import { environment } from 'src/environments/environment';

const API_URL = environment.apiUrlPersona;

@Injectable()
export class InformacionBancariaService {
  header = new Headers({ 'Content-Type': 'application/json' });

  constructor(private http: HttpClient) {}

  getInformacionBancariaService(): Observable<BodyListResponse<InformacionBancariaDTO>> {
    return this.http.get<BodyListResponse<InformacionBancariaDTO>>(API_URL + '/api/v1/informacionBancaria/todos');
  }

  guardarInformacionBancariaService(informacionBancariaDTO: InformacionBancariaDTO): Observable<InformacionBancariaDTO> {
    return this.http.post<InformacionBancariaDTO>(API_URL + '/api/v1/informacionBancaria', informacionBancariaDTO);
  }

  getInformacionBancariaPorCodigoInformacionBancariaService(codigoInformacionBancaria: string): Observable<BodyResponse<InformacionBancariaDTO>> {
    return this.http.get<BodyResponse<InformacionBancariaDTO>>(API_URL + '/api/v1/informacionBancaria/' + codigoInformacionBancaria);
  }
}
